import React, { useState } from "react";
import { UploadCloud } from "lucide-react";
import './RegisterDoktorRightSideFirst.css';

const RegisterDoktorRightSideFirst = ({ setShowSecondStep }) => {
    const [files, setFiles] = useState([]);
    const [dragActive, setDragActive] = useState(false);

    // 📌 Dosya seçim butonu ile seçildiğinde çalışacak fonksiyon
    const handleFileSelect = (event) => {
        const selectedFiles = Array.from(event.target.files);
        setFiles((prevFiles) => [...prevFiles, ...selectedFiles]);
    };

    // 📌 Sürüklenen dosyanın içeriye girmesi
    const handleDragEnter = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setDragActive(true);
    };

    // 📌 Sürükleme iptal edilirse
    const handleDragLeave = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setDragActive(false);
    };

    // 📌 Dosyanın sürükleyip bırakıldığında çalışacak fonksiyon
    const handleDrop = (event) => {
        event.preventDefault();
        event.stopPropagation();
        setDragActive(false);

        const droppedFiles = Array.from(event.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
    };

    return (
        <div className="file-upload-container">
            <p className="upload-info">
                Terapist ve Doktor olarak kayıt olanlar CV ve Lisans Belgelerini Yüklemek Zorundadır!
            </p>
            <div className="kutucuk">
                <label><input type="checkbox" /> Kutucuğu işaretlemeniz, Hizmet Şartlarımızı, Gizlilik Politikamızı, kabul ettiğiniz anlamına gelir.</label>
            </div>
            <div
                className={`drop-zone ${dragActive ? "active" : ""}`}
                onDragEnter={handleDragEnter}
                onDragOver={handleDragEnter}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
            >
                <UploadCloud size={48} strokeWidth={1.5} className="upload-icon" />
                <p>Dosyayı seç veya sürükle</p>
                <p className="upload-format">JPEG ve PDF formatında, 3MB’yi geçmemeli!</p>
                <input
                    type="file"
                    id="fileInput"
                    className="hidden-input"
                    multiple
                    accept=".jpg,.jpeg,.png,.pdf"
                    onChange={handleFileSelect}
                />
                <label htmlFor="fileInput" className="upload-button">Dosya Yükle</label>
            </div>

            {/* Yüklenen dosyaları listeleme alanı */}
            {files.length > 0 && (
                <div className="file-list">
                    {files.map((file, index) => (
                        <div key={index} className="file-item">
                            <span className="file-name">{file.name}</span>
                            <span className="file-size">{(file.size / 1024).toFixed(2)} KB</span>
                        </div>
                    ))}
                </div>
            )}

            <div class="button-container">
                <button class="submit-button" onClick={() => setShowSecondStep(true)}>Gönder</button>
            </div>

        </div>
    );
};


export default RegisterDoktorRightSideFirst;
